import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isStrictObject } from '../utils/helper';
function defineValueProp(Node, name, _ref) {
  var _ref$key = _ref.key,
    key = _ref$key === void 0 ? name : _ref$key;
  Node.prototype[name] = function (value) {
    if (arguments.length === 0) return this.attr(key);
    return this.attr(key, value);
  };
}
function defineArrayProp(Node, name, _ref2) {
  var _ref2$key = _ref2.key,
    key = _ref2$key === void 0 ? name : _ref2$key;
  Node.prototype[name] = function (value) {
    if (arguments.length === 0) return this.attr(key);
    if (Array.isArray(value)) return this.attr(key, value);
    var array = [].concat(_toConsumableArray(this.attr(key) || []), [value]);
    return this.attr(key, array);
  };
}
function defineObjectProp(Node, name, _ref3) {
  var _ref3$key = _ref3.key,
    k = _ref3$key === void 0 ? name : _ref3$key;
  Node.prototype[name] = function (key, value) {
    if (arguments.length === 0) return this.attr(k);
    if (arguments.length === 1 && typeof key !== 'string') {
      return this.attr(k, key);
    }
    var obj = this.attr(k) || {};
    obj[key] = arguments.length === 1 ? true : value;
    return this.attr(k, obj);
  };
}
function defineMixProp(Node, name, descriptor) {
  Node.prototype[name] = function (key) {
    if (arguments.length === 0) return this.attr(name);
    if (Array.isArray(key)) return this.attr(name, {
      items: key
    });
    if (isStrictObject(key) && (key.title !== undefined || key.items !== undefined)) {
      return this.attr(name, key);
    }
    if (key === null || key === false) return this.attr(name, key);
    var obj = this.attr(name) || {};
    var _obj$items = obj.items,
      items = _obj$items === void 0 ? [] : _obj$items;
    items.push(key);
    obj.items = items;
    return this.attr(name, obj);
  };
}
function defineNodeProp(Node, name, _ref4) {
  var ctor = _ref4.ctor;
  Node.prototype[name] = function (hocMark) {
    var node = this.append(ctor);
    if (name === 'mark') {
      node.type = hocMark;
    }
    return node;
  };
}
function defineContainerProp(Node, name, _ref5) {
  var ctor = _ref5.ctor;
  Node.prototype[name] = function () {
    this.type = null;
    return this.append(ctor);
  };
}
/**
 * A decorator to define different type of attribute setter or
 * getter for current node.
 */
export function defineProps(descriptors) {
  return function (Node) {
    for (var _i = 0, _Object$entries = Object.entries(descriptors); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        descriptor = _Object$entries$_i[1];
      var type = descriptor.type;
      if (type === 'value') defineValueProp(Node, name, descriptor);else if (type === 'array') defineArrayProp(Node, name, descriptor);else if (type === 'object') defineObjectProp(Node, name, descriptor);else if (type === 'node') defineNodeProp(Node, name, descriptor);else if (type === 'container') defineContainerProp(Node, name, descriptor);else if (type === 'mix') defineMixProp(Node, name, descriptor);
    }
    return Node;
  };
}
export function nodeProps(node) {
  return Object.fromEntries(Object.entries(node).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      name = _ref7[0],
      ctor = _ref7[1];
    return [name, {
      type: 'node',
      ctor: ctor
    }];
  }));
}